module.exports = __webpack_public_path__ + "static/media/getDiagnostics.js.65b0979a.flow";